var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconProfileOrange(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 82.1 88.8",
    style: {
      enableBackground: "new 0 0 82.1 88.8"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#333333;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M0,44.4c0-22.7,18.4-41,41.1-41s41.1,18.5,41,41.1C82,67.2,63.6,85.5,41,85.4C18.3,85.4,0,67,0,44.4z  M31.3,48.4c-9.2-6.7-9.4-18.5-3.5-25.4c6.2-7.3,16.8-8.3,24.2-2.3c3.5,3,5.7,6.7,6.1,11.2c0.7,6.8-1.9,12.2-7.4,16.4 c4.4,1.7,8.2,4.2,11.2,7.6c3.1,3.4,5.2,7.4,6.4,11.9c12.5-14.2,12.4-37.5-4.1-51.3c-15.6-13.3-39.3-10.9-52,5.9 C0,38.6,4.7,58.4,13.7,67.9C16.4,58.6,22.3,52.1,31.3,48.4z M41.7,80.6c0.8-0.1,2.4-0.1,4-0.3c6.1-0.8,11.7-3,16.8-6.7 c2-1.5,2-1.6,1.4-4.1c-3-11.9-14.2-19.5-26.3-17.7c-10,1.5-18.1,9.7-19.5,19.6c-0.1,0.5-0.1,0.8,0.3,1.1 C25,77.8,32.5,80.5,41.7,80.6z M41.1,46.6c6.8,0,12.5-5.6,12.5-12.5c0-6.8-5.7-12.5-12.5-12.5s-12.5,5.7-12.4,12.5 C28.6,41,34.3,46.6,41.1,46.6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconProfileOrange);
export default __webpack_public_path__ + "static/media/icon-profile-orange.8a6e74c937c809f7ef49904e1b2e4568.svg";
export { ForwardRef as ReactComponent };